export const jobVacancies = [
  {
    id: 1,
    title: 'Data Analyst Instructor',
    type: 'Part Time',
    location: 'Remote',
    salary: 'Competitive',
    posted: '31 Desember 2025',
    category: 'Instructor',
    description: 'Kami mencari Data Analyst berpengalaman untuk mengajar di bootcamp kami.',
    responsibilities: [
      'Mengajar materi Data Analysis dengan Python, SQL, dan Excel',
      'Membimbing siswa dalam project portfolio',
      'Mereview dan memberikan feedback pada tugas siswa',
      'Membuat dan update materi pembelajaran',
      'Melakukan sesi mentoring 1-on-1'
    ],
    requirements: [
      'Minimal 1 tahun pengalaman sebagai Data Analyst',
      'Menguasai Python (Pandas, NumPy, Matplotlib)',
      'Menguasai SQL dan database relational',
      'Menguasai Excel tingkat lanjut',
      'Memiliki passion untuk mengajar',
      'Komunikasi yang baik',
      'Portfolio project yang dapat ditunjukkan'
    ],
    benefits: [
      'Gaji kompetitif',
      'Flexible working hours',
      'Remote working',
      'Kesempatan mengembangkan skill mengajar',
      'Networking dengan profesional data'
    ]
  },
  {
    id: 2,
    title: 'Data Science Instructor',
    type: 'Part Time',
    location: 'Remote',
    salary: 'Competitive',
    posted: '31 Desember 2025',
    category: 'Instructor',
    description: 'Bergabunglah sebagai instructor untuk mengajar Data Science dan Machine Learning di bootcamp kami.',
    responsibilities: [
      'Mengajar materi Data Science dan Machine Learning',
      'Membimbing siswa dalam ML projects',
      'Code review dan feedback pada project siswa',
      'Membuat dan update materi pembelajaran',
      'Sesi Q&A dan mentoring dengan siswa',
      'Berbagi best practices dari industri'
    ],
    requirements: [
      'Minimal 1 tahun pengalaman di Data Science/ML',
      'Menguasai Python untuk ML (Scikit-learn, TensorFlow/PyTorch)',
      'Pengalaman dengan end-to-end ML projects',
      'Familiar dengan deployment ML models',
      'Memiliki passion untuk mengajar',
      'Komunikasi yang baik dan sabar',
      'Portfolio ML projects yang dapat ditunjukkan'
    ],
    benefits: [
      'Gaji kompetitif',
      'Flexible working hours',
      'Remote working',
      'Kesempatan sharing knowledge',
      'Build personal brand sebagai instructor'
    ]
  },
  {
    id: 3,
    title: 'Excel & Spreadsheet Instructor',
    type: 'Part Time',
    location: 'Remote',
    salary: 'Competitive',
    posted: '31 Desember 2025',
    category: 'Instructor',
    description: 'Ajarkan Excel, Google Sheets, dan spreadsheet skills untuk data analysis di bootcamp kami.',
    responsibilities: [
      'Mengajar Excel tingkat basic hingga advanced',
      'Mengajar Google Sheets dan Google Workspace',
      'Membimbing siswa dalam spreadsheet projects',
      'Membuat case study dan exercises',
      'Review dan feedback pada tugas siswa',
      'Membuat tutorial video dan dokumentasi'
    ],
    requirements: [
      'Minimal 1 tahun pengalaman menggunakan Excel/Spreadsheet secara profesional',
      'Menguasai Excel advanced (Pivot Tables, VLOOKUP, Macros, Power Query)',
      'Menguasai Google Sheets dan Google Workspace',
      'Familiar dengan data visualization di spreadsheet',
      'Memiliki passion untuk mengajar',
      'Komunikasi yang baik',
      'Portfolio atau case study yang dapat ditunjukkan'
    ],
    benefits: [
      'Gaji kompetitif',
      'Flexible working hours',
      'Remote working',
      'Kesempatan mengembangkan skill mengajar',
      'Networking dengan profesional data'
    ]
  }
];
